import { EntityResolver } from "../../Services/EntityResolver";
import { EntityNavigator } from "../../Services/EntityNavigator";
import { EntityErrorHandler } from "../../Services/EntityErrorHandler";
import { useUserStore } from "../../Stores/User";
import { RouteHelper } from "../../Helpers/RouteHelper";
import { ROUTE_NAMES } from "../../Constants/routes";
import { useAppState } from "../../Stores/AppState";
import { useWorkspace } from "../../Stores/Workspaces";

export async function handleWorkEntityNavigation(to, from, next) {
    // Check if this is a URL-only update (entity already active)
    // Check flag BEFORE any async operations to catch it reliably
    const shouldSkip = RouteHelper.skipEntityNavigation;

    if (shouldSkip) {
        // Reset flag and skip EntityNavigator to prevent LocationAnimation
        // Entity is already active, we're just syncing URL
        RouteHelper.skipEntityNavigation = false;
        next();
        return;
    }

    // Skip if navigating from same work entity route with same identifier
    if (
        from.name === ROUTE_NAMES.WORK_ENTITY &&
        from.params.entityIdentifier === to.params.entityIdentifier
    ) {
        next();
        return;
    }

    const entityId = to.params.entityIdentifier;

    // Validate universal ID format
    if (!EntityResolver.isValidFormat(entityId)) {
        EntityErrorHandler.handleError({ response: { status: 400 } });
        useWorkspace().clearLastClickedEntity();
        next("/work");
        return;
    }

    try {
        // Ensure app is initialized
        const userStore = useUserStore();
        await userStore.initialize();

        if (useAppState().skip_locate_animation) {
            useAppState().skip_locate_animation = false;
            next();
            return;
        }

        // Resolve universal ID to entity data
        const entityData = await EntityResolver.resolveEntity(entityId);

        // Navigate to entity (loads data + triggers LocationAnimation)
        await EntityNavigator.navigateToEntity(entityData);

        next();
    } catch (error) {
        console.log(error);

        useWorkspace().clearLastClickedEntity();
        next("/work");
        EntityErrorHandler.handleError(error);
    }
}
